import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/site-workspace");

export const Route = createFileRoute("/site-workspace/")({
  head: () => ({
    meta: [
      { title: "Site workspace — LevelLoad" },
      {
        name: "description",
        content: "Search a site by code or name and open its workspace in LevelLoad.",
      },
      { property: "og:title", content: "Site workspace — LevelLoad" },
      {
        property: "og:description",
        content: "Search a site by code or name and open its workspace in LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
